<template>
  <div class="home">
    <p>Redirecting to sign in...</p>
  </div>
</template>

<script>
export default {
  name: "home",
  mounted() {
    this.$router.replace("/login");
  },
};
</script>

<style scoped>
.home {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #4a5568;
  font-size: 16px;
}
</style>
